import './PermissionButton.css';
import React from 'react';
import { Permissable, Permission, usePermission } from '../../model/permission';
import { Icon } from '../Icon/Icon';
import { IconName } from '../Icon/IconName';
import GlobalProps from '../globalProps';

interface Props<T extends Permissable> extends GlobalProps {
  model?: T;
  permission: Permission<T>;
  onClick: () => void;
  name: IconName;
  loading?: boolean;
  hideLock?: boolean;
  tooltip?: string;
  disabled?: boolean;
  title?: string;
  size?: number;
}

export function PermissionButton<T extends Permissable>({
  model,
  permission,
  onClick,
  name,
  loading,
  hideLock,
  tooltip,
  className,
  style,
  disabled,
  title,
  size,
}: Props<T>): JSX.Element | null {
  const hasPermission = usePermission(model, permission);

  if (hasPermission) {
    return (
      <button className="permission-button" onClick={onClick} title={title}>
        <Icon
          className={className}
          style={style}
          name={name}
          loading={loading}
          tooltip={tooltip}
          disabled={disabled}
          size={size}
        />
      </button>
    );
  }

  if (hideLock) {
    return null;
  }

  return <Icon className={className} style={style} name="lock" tooltip={tooltip} />;
}
